module.exports = __webpack_public_path__ + "img/square-parking-slash.924d0cb9.svg";